import Vue from "vue";
import Vuex from "vuex";
/* 模块 */
import app from "./modules/app.js"; // 应用
import userCompany from "./modules/userCompany"; // 公司
import notification from "./modules/notification"; // 待办
// 数据
import platDataMap from "@/data/system/platDataMap.js";

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        systemType: platDataMap.name
    },
    getters: {
        systemConfig: (state) => platDataMap[state.systemType] || {},
        systemTitle: (state) => platDataMap[state.systemType].title
    },
    mutations: {
    },
    actions: {
        // 分发更新数据 当前user, appID, compId
        setInfo ({ commit }, info) {
            info = info || {};
            commit("updateUserData", info.userData || {});
            commit("updateAuthtoken", info.authtoken || "");
            commit("updateAppId", info.appId);
            commit("updateCompany", { _id: info.companyId });
        }
    },
    modules: {
        app,
        userCompany,
        notification
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js